import {
  IncidentActionType,
  SubParticipant,
} from '@collector/sportsapi-client-legacy'
import { getCurrentEvent } from '@mobile/globalState/event'
import * as sportsAPI from '@mobile/globalState/sportsAPI'
import { useEventSubParticipants } from '@mobile/views/Relation/useEventSubParticipants'

import IncidentAction, { ProbableData } from '../Incidents/IncidentAction'

export type UpdateEventSubParticipantsDTO = (Pick<
  SubParticipant,
  'id' | 'stats'
> & { team_id: number })[]

export default class UpdateEventSubParticipants extends IncidentAction {
  public readonly type = 'SwapIncident'

  constructor(public dto: UpdateEventSubParticipantsDTO) {
    super()
  }

  public override applyProbableResult({
    probableIncidents,
  }: ProbableData): void {
    const incident = probableIncidents.find(
      (probableIncident) => probableIncident.id === this.actionOrIncidentId,
    )

    if (incident) {
      incident.action = IncidentActionType.DELETE
    }
  }

  private appendLineupIdForEachSubParticipant(lineups: SubParticipant[]): void {
    this.dto = this.dto.map((subParticipant) => ({
      ...subParticipant,
      lineup_id:
        lineups.find(({ id }) => id === subParticipant.id)?.lineup_id ??
        undefined,
    }))
  }

  public async execImpl(): Promise<void> {
    const event = getCurrentEvent()

    const getEventSubParticipantsResponse =
      await sportsAPI.state.client.getEventLineups(event.id)

    this.appendLineupIdForEachSubParticipant(
      getEventSubParticipantsResponse.api.data.sub_participants,
    )

    const response = await sportsAPI.state.client.updateEventSubParticipants(
      event.id,
      this.dto,
    )

    useEventSubParticipants().updateSubParticipants(
      response.api.data.sub_participants,
    )
  }
}
